import { getters } from "../store.js";
const axios = require("axios").default;

const getDatabase = function() {
  return axios.get(
      `${process.env.VUE_APP_S3_URL}${process.env.VUE_APP_FILE_NAME}`
  );
};

const getProducts = function() {
  return getters.selectAllFrom("products");
};
const getServices = function() {
  return getters.selectAllFrom("services");
};
const getCountries = function() {
  return getters.selectAllFrom("countries");
};
const getOperators = function() {
  return getters.selectAllFrom("operators");
};
const getRegions = function() {
  return getters.selectAllFrom("regions");
};
export {
  getDatabase,
  getProducts,
  getOperators,
  getCountries,
  getServices,
  getRegions
};
